import SwissFranc from "./SwissFranc";

export * from "./Banknote";
export * from "./Bitcoin";
export * from "./CircleDollarSign";
export * from "./Currency";
export * from "./DollarSign";
export * from "./Euro";
export * from "./IndianRupee";
export * from "./JapaneseYen";
export * from "./PoundSterling";
export * from "./PhilippinePeso";
export * from "./Receipt";
export * from "./ReceiptCent";
export * from "./ReceiptEuro";
export * from "./ReceiptIndianRupee";
export * from "./ReceiptJapneseYen";
export * from "./ReceiptPoundSterling";
export * from "./ReceiptRussianRuble";
export * from "./ReceiptSwissFranc";
export * from "./RussianRubie";
export * from "./SwissFranc";

export const Currencyss = {
  SwissFranc,
};
